// extracted by mini-css-extract-plugin
export default {"documentationLinkContainer":"content-page-header-documentation-link__documentation-link-container__VGPkU"};